import { useContext, useState }                                  from "react";
import { Users, Search }                                         from "lucide-react";
import CrewCard                                                  from "@/components/CrewCard";
import Context                                                   from "@/provider/Context";
import { get_total_xp_crews, get_total_members_crew,
  get_maior_xp_crew, ordenar_crews }                             from "@/utils/CrewFunction";
import { formatar_compacto }                                     from "@/utils/RpgFunction";
import Footer                                                    from "@/components/common/Footer";

export default function CrewsPage() {
  const { Crews, Carregado }                                = useContext(Context);
  const crews_total_members                                 = get_total_members_crew(Crews);
  const crews_total_xp                                      = get_total_xp_crews(Crews);
  const maior_xp_crew                                       = get_maior_xp_crew(Crews);

  const [searchTerm, setSearchTerm]                         = useState("");
  const filteredCrews                                       = ordenar_crews(Crews).filter((crew) => (crew?.nome || "").toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="min-h-screen">
      <section className="pt-24 pb-8">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/20 border border-primary/30 mb-4">
            <Users className="w-4 h-4 text-primary" />
            <span className="text-sm font-rajdhani text-primary-foreground">
              Crews do Void
            </span>
          </div>

          <h1 className="font-orbitron text-4xl md:text-5xl font-black text-neon mb-3">
            CREWS
          </h1>

          <p className="text-muted-foreground font-rajdhani max-w-xl mx-auto">
            As crews mais poderosas do Blox Fruits, ordenadas pelo XP somado dos membros. Encontre sua legião.
          </p>

          {/* Search */}
          <div className="max-w-md mx-auto mt-6">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
              <input
                type="text"
                placeholder="Buscar crew..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-xl bg-secondary border border-border font-rajdhani placeholder:text-muted-foreground focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto">
            <div className="void-card p-4 text-center min-w-0">
              <p className="font-orbitron text-xl sm:text-2xl font-bold break-words text-primary">
                {Crews.length}
              </p>
              <p className="text-xs text-muted-foreground">Crews</p>
            </div>

            <div className="void-card p-4 text-center min-w-0">
              <p className="font-orbitron text-xl sm:text-2xl font-bold break-words text-primary">
                {crews_total_members}
              </p>
              <p className="text-xs text-muted-foreground">Total Membros</p>
            </div>

            <div className="void-card p-4 text-center min-w-0">
              <p className="font-orbitron text-xl sm:text-2xl font-bold break-words text-cosmic-gold">
                {formatar_compacto(crews_total_xp)}
              </p>
              <p className="text-xs text-muted-foreground">XP Somado</p>
            </div>
          </div>
        </div>
      </section>

      {/* Crews Grid */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">{ filteredCrews.map((crew, idx) => ( <CrewCard key={crew.slug || crew.nome || idx} crew={crew} maiorXp={maior_xp_crew} />)) }</div>

          {filteredCrews.length === 0 && (
            <div className="text-center py-16">
              <Users className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
              <p className="text-xl font-orbitron text-muted-foreground">
                {Carregado ? "Nenhuma crew encontrada" : "Carregando crews..."}
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
